import { useNavigate } from 'react-router-dom';
import { ArrowRight, Landmark } from 'lucide-react';

const MON_BG = 'https://images.unsplash.com/photo-1564507592333-c60657eea523?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxUYWolMjBNYWhhbCUyMEFncmF8ZW58MHx8fHwxNzkxNTYyMjg4fDA&ixlib=rb-4.1.0&q=85';

export default function MonumentHomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6"
      style={{ backgroundImage: `url(${MON_BG})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}
    >
      <div className="bg-white/95 backdrop-blur-md border-4 border-white rounded-3xl shadow-2xl p-8 sm:p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-stone-500 to-stone-800 flex items-center justify-center mx-auto mb-4 shadow-lg border-4 border-white">
          <Landmark className="w-10 h-10 text-white" strokeWidth={2.5} />
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl font-black text-gray-900 mb-2">
          Guess the Monument!
        </h1>
        <p className="font-body text-base text-gray-600 mb-6 leading-relaxed">
          Look at the photo, read the starting letter hint, and name the famous Indian monument!
        </p>

        <div className="flex justify-center gap-3 mb-6">
          <span className="bg-stone-100 text-stone-700 text-xs font-bold px-3 py-1.5 rounded-full">15 Questions</span>
          <span className="bg-stone-100 text-stone-700 text-xs font-bold px-3 py-1.5 rounded-full">Indian Monuments</span>
        </div>

        <button
          data-testid="start-monument-quiz"
          onClick={() => navigate('/monument/play')}
          className="bg-gradient-to-r from-stone-600 to-stone-800 text-white font-black text-xl py-4 px-10 rounded-full border-b-[6px] border-stone-950 active:border-b-0 active:translate-y-[6px] transition-all hover:from-stone-500 hover:to-stone-700 flex items-center gap-3 mx-auto shadow-lg"
        >
          Start!
          <ArrowRight className="w-6 h-6" />
        </button>

        <button
          data-testid="monument-back-studio"
          onClick={() => navigate('/')}
          className="mt-5 text-gray-500 font-bold text-sm hover:text-gray-800 transition-colors underline"
        >
          Back to Studio
        </button>
      </div>
    </div>
  );
}
